module.exports = "<img ng-src=\"{{ctrl.getVideoImage()}}\" width=\"100%\" style=\"padding-top: 10px;\"/>"